const translations = {
  DE: {
    // Header
    'header.officialName': 'Schweizerische Eidgenossenschaft',
    'header.frenchName': 'Confédération suisse',
    'header.italianName': 'Confederazione Svizzera',
    'header.romanshName': 'Confederaziun svizra',
    'header.agency': 'Bundeskanzlei BK',
    'header.contact': 'Kontakt',
    'header.media': 'Medien',
    'header.legalization': 'Legalisationen',
    'header.jobs': 'Stellenangebot',
    'header.search': 'Suchen',
    'header.topics': 'Themen A-Z',
    
    // Navigation
    'nav.government': 'Unterstützung der Regierung',
    'nav.politicalRights': 'Politische Rechte',
    'nav.digitalTransformation': 'Digitale Transformation und IKT-Lenkung',
    'nav.documentation': 'Dokumentation',
    'nav.about': 'Über die Bundeskanzlei',
    
    // Breadcrumb
    'breadcrumb.home': 'Startseite',
    'breadcrumb.politicalRights': 'Politische Rechte',
    'breadcrumb.initiatives': 'Volksinitiativen',
    'breadcrumb.pending': 'Hängige Volksinitiativen',
    'breadcrumb.collection': 'Im Sammelstadium',
    
    // Sidebar
    'sidebar.politicalRights': 'Politische Rechte',
    'sidebar.initiatives': 'Volksinitiativen',
    'sidebar.collection': 'Im Sammelstadium',
    'sidebar.counting': 'In Auszählung',
    'sidebar.federalCouncil': 'Beim Bundesrat hängig',
    'sidebar.parliament': 'Beim Parlament hängig',
    'sidebar.ready': 'Abstimmungsreife Volksinitiativen',
    'sidebar.appeal': 'Beschwerde gegen Verfügung hängig',
    'sidebar.deadlines': 'Ordentliche Behandlungsfristen',
    
    // Initiative List
    'initiatives.title': 'Im Sammelstadium',
    'initiatives.pdf': 'Unterschriftenlisten',
    'initiatives.listTitle': 'Titel',
    'initiatives.hint': 'Klicken Sie auf eine Initiative, um mehr zu erfahren und digitale Unterschrift zu leisten.',
    
    // Initiative Detail
    'detail.back': '← Zurück zur Liste',
    'detail.title': 'Eidgenössische Volksinitiative',
    'detail.reference': 'Referenz:',
    'detail.fullText': 'Die Initiative im Wortlaut',
    'detail.form': 'Form:',
    'detail.committee': 'Komitee:',
    'detail.preliminaryReview': 'Vorprüfung vom:',
    'detail.collectionEnd': 'Ablauf Sammelfrist:',
    'detail.collectionStart': 'Sammelbeginn:',
    'detail.date': 'Datum',
    'detail.source': 'Fundstelle',
    
    // Warning
    'warning.fraud': 'Bestechung oder Fälschung bei der Unterschriftensammlung ist nach Art. 281 oder 282 des Strafgesetzbuches strafbar.',
    
    // Signature Form
    'form.title': 'Digitale Unterschrift',
    'form.description': 'Bitte füllen Sie das Formular aus und leisten Sie eine digitale Unterschrift. Nur berechtigte Stimmbürgerinnen und Stimmbürger dürfen unterschreiben.',
    'form.lastName': 'Name',
    'form.firstName': 'Vornamen',
    'form.birthDate': 'Geburtsdatum (Tag/Monat/Jahr)',
    'form.address': 'Wohnadresse (Strasse und Hausnummer)',
    'form.postalCode': 'Postleitzahl',
    'form.city': 'Ort',
    'form.signature': 'Eigenhändige Unterschrift',
    'form.save': 'Unterschrift speichern',
    'form.clear': 'Löschen',
    'form.submit': 'Unterschrift übermitteln',
    'form.submitted': '✓ Erfolgreich übermittelt!',
    'form.deadline': 'Abgabe bis:',
    'form.missingSignature': 'Bitte leisten Sie eine Unterschrift.',
    'form.missingCaptcha': 'Bitte bestätigen Sie, dass Sie kein Roboter sind.',
    'form.pdfError': 'Fehler beim Generieren der PDF. Bitte versuchen Sie es erneut.',
    
    // Feedback Modal
    'feedback.success': '✓ Unterschrift erfolgreich übermittelt!',
    'feedback.thankYou': 'Vielen Dank für Ihre Unterschrift!',
    'feedback.saved': 'Ihre digitale Unterschrift wurde erfolgreich gespeichert.',
    'feedback.preview': 'PDF-Vorschau',
    'feedback.download': '📥 PDF erneut herunterladen',
    'feedback.nextSteps': 'Nächste Schritte:',
    'feedback.save': 'Bewahren Sie Ihr PDF sicher auf',
    'feedback.submitted': 'Die Unterschrift wird an das Komitee übermittelt',
    'feedback.email': 'Sie erhalten eine Bestätigungs-E-Mail',
    'feedback.close': 'Schliessen',
    
    // Error
    'error.notFound': 'Initiative nicht gefunden',
    'error.backToList': 'Zurück zur Liste',
    
    // Footer
    'footer.contact': 'Fachkontakt',
    'footer.lastUpdate': 'Letzte Änderung 29.10.2025 11:26',
    'footer.backToTop': 'Zum Seitenanfang'
  },
  
  FR: {
    // Header
    'header.officialName': 'Confédération suisse',
    'header.frenchName': 'Confédération suisse',
    'header.italianName': 'Confederazione Svizzera',
    'header.romanshName': 'Confederaziun svizra',
    'header.agency': 'Chancellerie fédérale CF',
    'header.contact': 'Contact',
    'header.media': 'Médias',
    'header.legalization': 'Légalisations',
    'header.jobs': 'Offres d\'emploi',
    'header.search': 'Rechercher',
    'header.topics': 'Thèmes A-Z',
    
    // Navigation
    'nav.government': 'Soutien au Conseil fédéral',
    'nav.politicalRights': 'Droits politiques',
    'nav.digitalTransformation': 'Transformation numérique et gouvernance des TIC',
    'nav.documentation': 'Documentation',
    'nav.about': 'À propos de la Chancellerie fédérale',
    
    // Breadcrumb
    'breadcrumb.home': 'Accueil',
    'breadcrumb.politicalRights': 'Droits politiques',
    'breadcrumb.initiatives': 'Initiative populaire',
    'breadcrumb.pending': 'Initiative populaire en cours',
    'breadcrumb.collection': 'En phase de collecte',
    
    // Sidebar
    'sidebar.politicalRights': 'Droits politiques',
    'sidebar.initiatives': 'Initiative populaire',
    'sidebar.collection': 'En phase de collecte',
    'sidebar.counting': 'En dépouillement',
    'sidebar.federalCouncil': 'En attente au Conseil fédéral',
    'sidebar.parliament': 'En attente au Parlement',
    'sidebar.ready': 'Initiative populaire prêtes à voter',
    'sidebar.appeal': 'Recours en attente',
    'sidebar.deadlines': 'Délais de traitement',
    
    // Initiative List
    'initiatives.title': 'En phase de collecte',
    'initiatives.pdf': 'Listes de signatures',
    'initiatives.listTitle': 'Titre',
    'initiatives.hint': 'Cliquez sur une initiative pour en savoir plus et signer numériquement.',
    
    // Initiative Detail
    'detail.back': '← Retour à la liste',
    'detail.title': 'Initiative populaire fédérale',
    'detail.reference': 'Référence:',
    'detail.fullText': 'Texte intégral de l\'initiative',
    'detail.form': 'Forme:',
    'detail.committee': 'Comité:',
    'detail.preliminaryReview': 'Examen préalable du:',
    'detail.collectionEnd': 'Expiration du délai:',
    'detail.collectionStart': 'Début de collecte:',
    'detail.date': 'Date',
    'detail.source': 'Référence',
    
    // Warning
    'warning.fraud': 'La corruption ou la falsification lors de la collecte de signatures est punissable selon les articles 281 ou 282 du code pénal.',
    
    // Signature Form
    'form.title': 'Signature numérique',
    'form.description': 'Veuillez remplir le formulaire et apposer votre signature numérique. Seuls les citoyens éligibles peuvent signer.',
    'form.lastName': 'Nom (manuscrit de préférence en majuscules)',
    'form.firstName': 'Prénoms (manuscrit de préférence en majuscules)',
    'form.birthDate': 'Date de naissance (Jour/Mois/Année)',
    'form.address': 'Adresse (rue et numéro)',
    'form.postalCode': 'Code postal',
    'form.city': 'Lieu',
    'form.signature': 'Signature manuscrite',
    'form.save': 'Enregistrer la signature',
    'form.clear': 'Effacer',
    'form.submit': 'Soumettre la signature',
    'form.submitted': '✓ Soumis avec succès!',
    'form.deadline': 'Échéance:',
    'form.missingSignature': 'Veuillez apposer une signature.',
    'form.missingCaptcha': 'Veuillez confirmer que vous n\'êtes pas un robot.',
    'form.pdfError': 'Erreur lors de la génération du PDF. Veuillez réessayer.',
    
    // Feedback Modal
    'feedback.success': '✓ Signature soumise avec succès!',
    'feedback.thankYou': 'Merci pour votre signature!',
    'feedback.saved': 'Votre signature numérique a été enregistrée avec succès.',
    'feedback.preview': 'Aperçu PDF',
    'feedback.download': '📥 Télécharger le PDF à nouveau',
    'feedback.nextSteps': 'Prochaines étapes:',
    'feedback.save': 'Conservez votre PDF en sécurité',
    'feedback.submitted': 'La signature sera transmise au comité',
    'feedback.email': 'Vous recevrez un e-mail de confirmation',
    'feedback.close': 'Fermer',
    
    // Error
    'error.notFound': 'Initiative non trouvée',
    'error.backToList': 'Retour à la liste',
    
    // Footer
    'footer.contact': 'Contact spécialisé',
    'footer.lastUpdate': 'Dernière modification 29.10.2025 11:26',
    'footer.backToTop': 'Retour en haut de la page'
  },
  
  IT: {
    // Header
    'header.officialName': 'Confederazione Svizzera',
    'header.frenchName': 'Confédération suisse',
    'header.italianName': 'Confederazione Svizzera',
    'header.romanshName': 'Confederaziun svizra',
    'header.agency': 'Cancelleria federale CF',
    'header.contact': 'Contatto',
    'header.media': 'Media',
    'header.legalization': 'Legalizzazioni',
    'header.jobs': 'Offerte di lavoro',
    'header.search': 'Cerca',
    'header.topics': 'Temi A-Z',
    
    // Navigation
    'nav.government': 'Sostegno al Consiglio federale',
    'nav.politicalRights': 'Diritti politici',
    'nav.digitalTransformation': 'Trasformazione digitale e governance ICT',
    'nav.documentation': 'Documentazione',
    'nav.about': 'Informazioni sulla Cancelleria federale',
    
    // Breadcrumb
    'breadcrumb.home': 'Homepage',
    'breadcrumb.politicalRights': 'Diritti politici',
    'breadcrumb.initiatives': 'Iniziativa popolare',
    'breadcrumb.pending': 'Iniziative popolari in corso',
    'breadcrumb.collection': 'In fase di raccolta',
    
    // Sidebar
    'sidebar.politicalRights': 'Diritti politici',
    'sidebar.initiatives': 'Iniziativa popolare',
    'sidebar.collection': 'In fase di raccolta',
    'sidebar.counting': 'In scrutinio',
    'sidebar.federalCouncil': 'In sospeso presso il Consiglio federale',
    'sidebar.parliament': 'In sospeso presso il Parlamento',
    'sidebar.ready': 'Iniziative popolari pronte per la votazione',
    'sidebar.appeal': 'Ricorso in attesa',
    'sidebar.deadlines': 'Termini di trattamento',
    
    // Initiative List
    'initiatives.title': 'In fase di raccolta',
    'initiatives.pdf': 'Elenchi di firme',
    'initiatives.listTitle': 'Titolo',
    'initiatives.hint': 'Fare clic su un\'iniziativa per saperne di più e firmare digitalmente.',
    
    // Initiative Detail
    'detail.back': '← Torna all\'elenco',
    'detail.title': 'Iniziativa popolare federale',
    'detail.reference': 'Riferimento:',
    'detail.fullText': 'Testo completo dell\'iniziativa',
    'detail.form': 'Forma:',
    'detail.committee': 'Comitato:',
    'detail.preliminaryReview': 'Esame preliminare del:',
    'detail.collectionEnd': 'Scadenza:',
    'detail.collectionStart': 'Inizio raccolta:',
    'detail.date': 'Data',
    'detail.source': 'Riferimento',
    
    // Warning
    'warning.fraud': 'La corruzione o la falsificazione nella raccolta delle firme è punibile secondo gli articoli 281 o 282 del codice penale.',
    
    // Signature Form
    'form.title': 'Firma digitale',
    'form.description': 'Compilare il modulo e apporre la firma digitale. Solo i cittadini eleggibili possono firmare.',
    'form.lastName': 'Nome (manoscritto preferibilmente in stampatello)',
    'form.firstName': 'Nomi (manoscritto preferibilmente in stampatello)',
    'form.birthDate': 'Data di nascita (Giorno/Mese/Anno)',
    'form.address': 'Indirizzo di residenza (via e numero civico)',
    'form.postalCode': 'Codice postale',
    'form.city': 'Località',
    'form.signature': 'Firma manoscritta',
    'form.save': 'Salva la firma',
    'form.clear': 'Cancella',
    'form.submit': 'Invia la firma',
    'form.submitted': '✓ Invio riuscito!',
    'form.deadline': 'Scadenza:',
    'form.missingSignature': 'Si prega di apporre una firma.',
    'form.missingCaptcha': 'Si prega di confermare di non essere un robot.',
    'form.pdfError': 'Errore durante la generazione del PDF. Riprovare.',
    
    // Feedback Modal
    'feedback.success': '✓ Firma inviata con successo!',
    'feedback.thankYou': 'Grazie per la sua firma!',
    'feedback.saved': 'La sua firma digitale è stata salvata con successo.',
    'feedback.preview': 'Anteprima PDF',
    'feedback.download': '📥 Scarica di nuovo il PDF',
    'feedback.nextSteps': 'Prossimi passi:',
    'feedback.save': 'Conservare il PDF in sicurezza',
    'feedback.submitted': 'La firma sarà trasmessa al comitato',
    'feedback.email': 'Riceverà un\'e-mail di conferma',
    'feedback.close': 'Chiudi',
    
    // Error
    'error.notFound': 'Iniziativa non trovata',
    'error.backToList': 'Torna all\'elenco',
    
    // Footer
    'footer.contact': 'Contatto specializzato',
    'footer.lastUpdate': 'Ultimo aggiornamento 29.10.2025 11:26',
    'footer.backToTop': 'Torna all\'inizio della pagina'
  },
  
  RM: {
    // Romansh translations (simplified)
    'header.officialName': 'Confederaziun svizra',
    'header.agency': 'Chanzlia federala CF',
    'header.contact': 'Contact',
    'nav.politicalRights': 'Dretgs politics',
    'breadcrumb.home': 'Pagina principala',
    'initiatives.title': 'En la fasa da collecziun',
    'detail.title': 'Iniziativa populara federala',
    'form.submit': 'Survender la suttascripziun',
    'feedback.success': '✓ Suttascripziun surventada cun success!'
  },
  
  EN: {
    // Header
    'header.officialName': 'Swiss Confederation',
    'header.frenchName': 'Confédération suisse',
    'header.italianName': 'Confederazione Svizzera',
    'header.romanshName': 'Confederaziun svizra',
    'header.agency': 'Federal Chancellery FC',
    'header.contact': 'Contact',
    'header.media': 'Media',
    'header.legalization': 'Legalizations',
    'header.jobs': 'Job vacancies',
    'header.search': 'Search',
    'header.topics': 'Topics A-Z',
    
    // Navigation
    'nav.government': 'Support for the Federal Council',
    'nav.politicalRights': 'Political Rights',
    'nav.digitalTransformation': 'Digital Transformation and ICT Governance',
    'nav.documentation': 'Documentation',
    'nav.about': 'About the Federal Chancellery',
    
    // Breadcrumb
    'breadcrumb.home': 'Home',
    'breadcrumb.politicalRights': 'Political Rights',
    'breadcrumb.initiatives': 'Popular Initiatives',
    'breadcrumb.pending': 'Pending Initiatives',
    'breadcrumb.collection': 'In Collection Stage',
    
    // Sidebar
    'sidebar.politicalRights': 'Political Rights',
    'sidebar.initiatives': 'Popular Initiatives',
    'sidebar.collection': 'In Collection Stage',
    'sidebar.counting': 'Being Counted',
    'sidebar.federalCouncil': 'Pending at Federal Council',
    'sidebar.parliament': 'Pending at Parliament',
    'sidebar.ready': 'Initiatives Ready for Vote',
    'sidebar.appeal': 'Appeal Pending',
    'sidebar.deadlines': 'Regular Processing Deadlines',
    
    // Initiative List
    'initiatives.title': 'In Collection Stage',
    'initiatives.pdf': 'Signature Lists',
    'initiatives.listTitle': 'Title',
    'initiatives.hint': 'Click on an initiative to learn more and sign digitally.',
    
    // Initiative Detail
    'detail.back': '← Back to List',
    'detail.title': 'Federal Popular Initiative',
    'detail.reference': 'Reference:',
    'detail.fullText': 'Full Text of the Initiative',
    'detail.form': 'Form:',
    'detail.committee': 'Committee:',
    'detail.preliminaryReview': 'Preliminary review from:',
    'detail.collectionEnd': 'Collection deadline:',
    'detail.collectionStart': 'Collection start:',
    'detail.date': 'Date',
    'detail.source': 'Reference',
    
    // Warning
    'warning.fraud': 'Bribery or falsification during signature collection is punishable under Articles 281 or 282 of the Criminal Code.',
    
    // Signature Form
    'form.title': 'Digital Signature',
    'form.description': 'Please fill out the form and provide a digital signature. Only eligible citizens may sign.',
    'form.lastName': 'Last Name (handwritten, preferably in block letters)',
    'form.firstName': 'First Names (handwritten, preferably in block letters)',
    'form.birthDate': 'Date of Birth (Day/Month/Year)',
    'form.address': 'Residential Address (Street and House Number)',
    'form.postalCode': 'Postal Code',
    'form.city': 'City',
    'form.signature': 'Handwritten Signature',
    'form.save': 'Save Signature',
    'form.clear': 'Clear',
    'form.submit': 'Submit Signature',
    'form.submitted': '✓ Successfully Submitted!',
    'form.deadline': 'Deadline:',
    'form.missingSignature': 'Please provide a signature.',
    'form.missingCaptcha': 'Please confirm you are not a robot.',
    'form.pdfError': 'Error generating PDF. Please try again.',
    
    // Feedback Modal
    'feedback.success': '✓ Signature Successfully Submitted!',
    'feedback.thankYou': 'Thank you for your signature!',
    'feedback.saved': 'Your digital signature has been saved successfully.',
    'feedback.preview': 'PDF Preview',
    'feedback.download': '📥 Download PDF Again',
    'feedback.nextSteps': 'Next Steps:',
    'feedback.save': 'Keep your PDF safe',
    'feedback.submitted': 'Signature will be submitted to the committee',
    'feedback.email': 'You will receive a confirmation email',
    'feedback.close': 'Close',
    
    // Error
    'error.notFound': 'Initiative Not Found',
    'error.backToList': 'Back to List',
    
    // Footer
    'footer.contact': 'Specialist Contact',
    'footer.lastUpdate': 'Last Updated 29.10.2025 11:26',
    'footer.backToTop': 'Back to Top'
  }
};

export default translations;

